import './itemsPerPageSelector.scss';

export default function ItemsPerPageSelector({ itemsPerPage, onItemsPerPageChange, totalItems }) {
  return (
    <div className="cs_items_per_page_selector">
      <div className="cs_items_info">
        <span className="cs_total_items">{totalItems} posts</span>
      </div>
      <div className="cs_items_per_page_control">
        <label>Show:</label>
        <select 
          value={itemsPerPage} 
          onChange={(e) => onItemsPerPageChange(Number(e.target.value))}
          className="cs_per_page_select"
        >
          <option value={5}>5</option>
          <option value={10}>10</option>
          <option value={15}>15</option>
        </select>
        <span>per page</span>
      </div>
    </div>
  );
}
